export class Ordersnew {
  public orderId: string = "";
  public customerNumber: number = 0;
  public distributionCenter: number = 0;
  public orderCreateSTP: string = "";
  public uniqueTrackingNumber: string = "";
  public uniqueTrackingNumberOld: string = "";
}
